/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAddress } from './ControlAddress';
import {
    ControlAddressFromJSON,
    ControlAddressFromJSONTyped,
    ControlAddressToJSON,
} from './ControlAddress';

/**
 * Request schema for organization search during admin client creation.
 * @export
 * @interface ControlAdminOrgSearchRequest
 */
export interface ControlAdminOrgSearchRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlAdminOrgSearchRequest
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlAdminOrgSearchRequest
     */
    domains: Array<string>;
    /**
     * 
     * @type {ControlAddress}
     * @memberof ControlAdminOrgSearchRequest
     */
    address?: ControlAddress;
}

/**
 * Check if a given object implements the ControlAdminOrgSearchRequest interface.
 */
export function instanceOfControlAdminOrgSearchRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "domains" in value;

    return isInstance;
}

export function ControlAdminOrgSearchRequestFromJSON(json: any): ControlAdminOrgSearchRequest {
    return ControlAdminOrgSearchRequestFromJSONTyped(json, false);
}

export function ControlAdminOrgSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAdminOrgSearchRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'domains': json['domains'],
        'address': !exists(json, 'address') ? undefined : ControlAddressFromJSON(json['address']),
    };
}

export function ControlAdminOrgSearchRequestToJSON(value?: ControlAdminOrgSearchRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'domains': value.domains,
        'address': ControlAddressToJSON(value.address),
    };
}

